import { useState } from "react";
import Layout from "../components/Layout";
import Card from "../components/Card";
import Input from "../components/Input";
import Button from "../components/Button";
import { login } from "../api/auth";

export default function LoginPage({ onLoggedIn }) {
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(username, password);
      onLoggedIn();
    } catch (e2) {
      setErr(e2.message || "login failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <Layout title="Admin Login">
      <div className="center">
        <Card>
          <form onSubmit={onSubmit} className="stack">
            <Input label="Username" value={username} onChange={(e) => setUsername(e.target.value)} />
            <Input label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
            {err ? <div className="error">{err}</div> : null}
            <Button type="submit" disabled={loading}>
              {loading ? "Giriş..." : "Giriş Yap"}
            </Button>
          </form>
        </Card>
      </div>
    </Layout>
  );
}
